import script from "./FormSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormSection.vue?vue&type=script&setup=true&lang=ts"

import "./FormSection.vue?vue&type=style&index=0&id=31aeee8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31aeee8c"]])

export default __exports__